"use client";

import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const stats = [
  { end: 50, label: "Happy Partners", suffix: "+" },
  { end: 120, label: "Projects Completed", suffix: "+" },
  { end: 4, label: "Years Experience", suffix: "+" },
];

export default function StatsSection() {
  const [ref, inView] = useInView({
    threshold: 0.5,
  });
  return (
    <motion.div
      ref={ref}
      className="flex flex-wrap justify-center gap-8 my-4 text-center"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      {stats.map(({ end, label, suffix }, i) => (
        <div key={i} className="flex flex-col items-center">
          <h3 className="text-4xl font-tertiary text-gradient ">
            {inView ? <CountUp start={0} end={end} duration={3} /> : end}
            {suffix}
          </h3>
          <p className="text-muted-foreground mt-1">{label}</p>
        </div>
      ))}
    </motion.div>
  );
}
